import { Box, Tab, Tabs, Typography } from '@mui/material'
import { useState } from 'react'
import { CategoriesTab } from './CategoriesTab'
import { CoverageTab } from './CoverageTab'
import { ReviewQueueTab } from './ReviewQueueTab'
import { SupplierMappingsTab } from './SupplierMappingsTab'
import './ProductCategories.css'

const TABS = ['Coverage', 'Review Queue', 'Supplier Mappings', 'Categories'] as const

type TabName = (typeof TABS)[number]

export default function ProductCategories() {
  const [tab, setTab] = useState<TabName>('Coverage')

  return (
    <Box className="product-categories-page">
      <Typography variant="h5" className="product-categories-title">
        Product Categories
      </Typography>
      <Tabs value={tab} onChange={(_e, next: TabName) => setTab(next)} className="product-categories-tabs">
        {TABS.map(name => (
          <Tab key={name} value={name} label={name} />
        ))}
      </Tabs>
      {tab === 'Coverage' && <CoverageTab />}
      {tab === 'Review Queue' && <ReviewQueueTab />}
      {tab === 'Supplier Mappings' && <SupplierMappingsTab />}
      {tab === 'Categories' && <CategoriesTab />}
    </Box>
  )
}
